<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import ApplicationLogoFull from "@/Components/ApplicationLogoFull.vue";

defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
});
</script>

<template>
    <AppLayout :title="__('Home')">
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="text-center">
                    <div class="w-3/4 mb-1 text-right lg:text-sm text-xs text-slate-500 font-light tracking-wide">{{ $page.props.app.instance }}</div>
                    <ApplicationLogoFull class="w-1/2 h-auto fill-theme-500 inline-block" />
                </div>
                <div class="bg-white mt-6 overflow-hidden shadow-xl sm:rounded-lg border-b border-gray-200">
                    <div class="p-6 sm:px-20">
                        <div class="mt-8 text-2xl">
                            {{ __('Welcome to :name Version :version', { 'name': $page.props.app.name, 'version': $page.props.app.version }) }}
                        </div>

                        <div class="mt-2 text-lg">
                            {{ $page.props.app.fullname }}
                        </div>

                        <div class="mt-6 text-gray-500">
                            <div>
                                {{ __("welcome.part1") }}
                                {{ __("welcome.part2") }}

                            </div>
                            <div class="pt-4">
                                {{ __("welcome.part3") }}


                            </div>
                            <div class="pt-4">
                                {{ __("welcome.part4") }}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
